import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

import { ProjectSetupModule } from '../project/project-setup.module';
import { ContextToolbarComponent } from './context-toolbar.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { SearchResultDialogComponent } from './search-result-dialog/search-result-dialog.component';
import { GlobalSearchResultDialogComponent } from './global-search-result-dialog/global-search-result-dialog.component';
import { MatListModule } from '@angular/material/list';
import { MatDialogModule } from '@angular/material/dialog';
import { StatusCircleModule } from '../shared/status-circle/status-circle.module';
import { UserManualDirective } from '../shared/user-manual/user-manual.directive';
import { MatTableModule } from '@angular/material/table';
import { A11yModule } from '@angular/cdk/a11y';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CameraScannerOverlayComponent } from './camera-scanner-overlay/camera-scanner-overlay.component';
import { PunchDialogModule } from '../shared/punch-dialog/punch-dialog.module';
import { ButtonModule } from 'primeng/button';
import { PopoverModule } from 'primeng/popover';
import { ContextLauncherComponent } from './context-launcher.component';

@NgModule({
  declarations: [ContextToolbarComponent, CameraScannerOverlayComponent, ContextLauncherComponent],
  imports: [
    CommonModule,
    StatusCircleModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    ProjectSetupModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    MatDialogModule,
    UserManualDirective,
    MatTableModule,
    A11yModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    SearchResultDialogComponent,
    GlobalSearchResultDialogComponent,
    PunchDialogModule,
    ButtonModule,
    PopoverModule,
  ],
  exports: [ContextToolbarComponent, ContextLauncherComponent],
})
export class ContextToolbarModule {}
